import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AccidentReportPersonsConstants as Constants } from "@/pages/AccidentReportPersons/AccidentReportPersonsConstants";

const bulletList = (items: readonly string[]): JSX.Element => (
  <List dense disablePadding sx={{ listStyleType: "disc", pl: 3 }}>
    {items.map((item) => (
      <ListItem
        key={item}
        disableGutters
        sx={{ display: "list-item", py: 0.25 }}
      >
        <Typography variant="body2">{item}</Typography>
      </ListItem>
    ))}
  </List>
);

type Step = { label: string; text?: string; subItems?: readonly string[] };

const stepList = (steps: readonly Step[]): JSX.Element => (
  <List dense disablePadding sx={{ listStyleType: "disc", pl: 3 }}>
    {steps.map((step) => (
      <ListItem
        key={step.label}
        disableGutters
        sx={{ display: "list-item", py: 0.25 }}
      >
        <Typography variant="body2">
          <Typography
            component="span"
            variant="body2"
            sx={{ fontWeight: "bold" }}
          >
            {step.label}
          </Typography>
          {step.text}
        </Typography>
        {step.subItems && bulletList(step.subItems)}
      </ListItem>
    ))}
  </List>
);

// 説明内容は初期で展開された状態とする
export const AccidentReportPersonsGuide = (): JSX.Element => {
  return (
    <Accordion
      defaultExpanded
      disableGutters
      elevation={0}
      sx={{
        border: "1px solid",
        borderColor: "grey.300",
        borderLeft: "4px solid",
        borderLeftColor: "info.main",
        borderRadius: 1,
        backgroundColor: "background.paper",
        "&:before": {
          display: "none",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          "&:hover": {
            backgroundColor: "action.hover",
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <InfoOutlinedIcon fontSize="small" color="info" />
          <Box>
            <Typography sx={{ fontWeight: "bold" }}>
              {Constants.GuideTitle}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {Constants.GuideToggleHint}
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Typography variant="body2">{Constants.GuidePurpose}</Typography>
        {/* 役割責任の定義はこの画面では持たず、従来どおり説明資料を正とする。
            参照先が埋もれて見落とされないよう、他の注意喚起と同様にAlertで目立たせる */}
        <Alert severity="info" sx={{ mt: 1, whiteSpace: "pre-wrap" }}>
          <Typography variant="body2">{Constants.GuideReference}</Typography>
        </Alert>

        <Box sx={{ mt: 1.5 }}>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            {Constants.GuidePartnerStepsTitle}
          </Typography>
          {stepList(Constants.GuidePartnerSteps)}
        </Box>

        {/* 削除→再登録でeラーニング受講履歴とのつながりが切れ得るため、ここでも注意喚起する */}
        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            {Constants.GuideCautionTitle}
          </Typography>
          {stepList(Constants.GuideCautions)}
        </Alert>

        <Box sx={{ mt: 1.5 }}>
          <Typography variant="body2" sx={{ fontWeight: "bold" }}>
            {Constants.GuideContactTitle}
          </Typography>
          <Typography variant="body2">
            Email：{Constants.GuideContactEmail}
          </Typography>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};
